import React, { ChangeEvent, useCallback, useMemo, useRef } from 'react';
import styled from 'styled-components';
import IconImage from '../../../assets/moviechoice.png';
// import AuthStore from '../../../store/AuthStore';

const Wrapper = styled.i`
    display: flex;
    flex-direction: column;
    padding: 0 12px;
`;

const Icon = styled.img`
    cursor: pointer;
    height: 80px;
    width: auto;
`;

const StyledInput = styled.input`
    display: none;
`

type Props = {
    className?: string
    onChange: (data: Blob) => void
    // 動画タイプ: 'lesson' はレッスンスイング動画、'coach' はコーチスイング動画
    videoType?: 'lesson' | 'coach'
}

const LocalMovieSelectButton: React.FC<Props> = ({
    className,
    onChange,
    videoType = 'lesson'
}) => {
    console.log(videoType);

    const inputRef = useRef<HTMLInputElement>(null);
    const handleIconClick = () => {
        inputRef.current?.click();
    }

    // videoTypeに応じてmaxSizeを計算
    // const maxSize = useMemo(() => {
    //     return videoType === 'coach' 
    //         ? AuthStore.coachSwingMovieMaxSize 
    //         : AuthStore.lessonSwingMovieMaxSize;
    // }, [videoType]);

    const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        const { files } = event.currentTarget;
        if (!files) {
            return;
        }

        const file = files.item(0);
        if (!file) {
            return
        }

        if (!/^video\/.*/.test(file.type)) {
            window.alert('動画ファイルを選択してください');
            // 入力値をリセット
            event.target.value = '';
            return;
        }

        // ファイルサイズチェック
        // if (file.size > (maxSize * 1024 * 1024)) {
        //     const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
        //     window.alert(
        //         `ファイルサイズが上限（${maxSize}MB）を超えているため、アップロードできません。\n` +
        //         `現在の動画サイズは ${fileSizeMB}MB です。\n` +
        //         `4Kなど高画質の動画は容量が大きくなることがあります。\n` +
        //         `タブレットの画質設定を見直して、${maxSize}MB以下の動画をお試しください。`
        //     );
        //     // 入力値をリセット
        //     event.target.value = '';
        //     return;
        // }

        onChange(file)
    }, [onChange]);
    // }, [onChange, maxSize]);

    return (
        <Wrapper className={className}>
            <Icon src={IconImage} onClick={handleIconClick} />
            <StyledInput type='file' accept='video/*' onChange={handleChange} ref={inputRef} />
        </Wrapper>
    )
}

export default LocalMovieSelectButton;
